import React from 'react';
import { useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQrcode, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { usePageTitle } from '../hooks/usePageTitle';
import { Card, CardBody, LayoutContainer, MessageBlock } from '../components/ui';
import '../styles/infrastructureScreens.css';

const MobileErrorPage = ({ error }) => {
  const { type } = useParams();
  const errorType = error || type;

  usePageTitle('Portal Autogestión');

  const getErrorMessage = () => {
    switch (errorType) {
      case 'token_expired':
        return {
          title: 'Sesión expirada',
          message: 'Tu sesión ha caducado. Por favor, solicita un nuevo código QR desde una computadora para continuar.'
        };
      case 'invalid_token':
        return {
          title: 'Acceso inválido',
          message: 'El enlace que estás usando ya no es válido. Necesitas generar un nuevo código QR desde una computadora.'
        };
      default:
        return {
          title: 'Error de acceso',
          message: 'Ha ocurrido un error. Por favor, solicita un nuevo código QR desde una computadora para continuar.'
        };
    }
  };

  const { title, message } = getErrorMessage();

  return (
    <div className="rg-infra-screen rg-mobile-error">
      <LayoutContainer size="md" className="rg-mobile-error__container">
        <Card className="rg-mobile-error__card rg-elevation-2">
          <CardBody className="rg-mobile-error__card-body">
            <div className="rg-mobile-error__icon-wrap" aria-hidden="true">
              <FontAwesomeIcon icon={faExclamationTriangle} className="rg-mobile-error__icon" />
            </div>

            <MessageBlock tone="warning" title={title} className="rg-mobile-error__message">
              {message}
            </MessageBlock>

            <div className="rg-mobile-error__hint">
              <FontAwesomeIcon icon={faQrcode} className="rg-mobile-error__hint-icon" aria-hidden="true" />
              <p className="rg-mobile-error__hint-text">
                Escanea un nuevo código QR para continuar con la digitalización de documentos.
              </p>
            </div>
          </CardBody>
        </Card>
      </LayoutContainer>
    </div>
  );
};

export default MobileErrorPage; 